// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-434b29d4] .el-form-item__label {\n  padding: 0 12px 0 0;\n}\n.max-fill[data-v-434b29d4] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
